import React from 'react';
import {
  DollarSign, ShoppingCart,
} from 'lucide-react';
import { KpiCard, LoadingSkeleton } from './_shared';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function RevenueTab({ data }) {
  if (!data) return <LoadingSkeleton />;
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <KpiCard icon={DollarSign} label="Total Revenue" value={`$${data.total_revenue?.toFixed(2) || '0'}`} color="#10B981" />
        <KpiCard icon={ShoppingCart} label="Total Orders" value={data.total_orders} color="#3B82F6" />
        <KpiCard icon={ShoppingCart} label="Abandoned Carts" value={data.abandoned_carts} color="#F59E0B" />
        <KpiCard icon={ShoppingCart} label="Total Carts" value={data.total_carts} color="#8B5CF6" />
      </div>
      <div className="bg-white rounded-xl border border-gray-100 p-6">
        <h3 className="text-sm font-semibold text-gray-900 flex items-center gap-2 mb-4">
          <DollarSign className="w-4 h-4 text-green-500" /> Orders
        </h3>
        {data.orders?.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-gray-400 text-xs border-b border-gray-100">
                <th className="pb-2 font-medium">Order ID</th><th className="pb-2 font-medium">Customer</th><th className="pb-2 font-medium text-right">Total</th><th className="pb-2 font-medium">Status</th><th className="pb-2 font-medium">Date</th>
              </tr></thead>
              <tbody>
                {data.orders.map((o, i) => (
                  <tr key={o.id} className="border-b border-gray-50 last:border-0">
                    <td className="py-2.5 text-gray-700 font-mono text-xs">{o.id?.slice(0, 8)}...</td>
                    <td className="py-2.5 text-gray-500">{o.customer_email}</td>
                    <td className="py-2.5 text-right font-mono text-gray-700">${o.total?.toFixed(2)}</td>
                    <td className="py-2.5"><span className="px-2 py-0.5 bg-green-50 text-green-600 text-xs rounded-full">{o.status}</span></td>
                    <td className="py-2.5 text-gray-400 text-xs">{o.created_at ? new Date(o.created_at).toLocaleDateString() : '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : <p className="text-gray-400 text-sm">No orders yet</p>}
      </div>
    </div>
  );
}
